import React from "react";
import List from "../modules/Tenants/List";

export function TenantsListPage(props) {
  return <List />;
}
